import { memo } from 'react';
import { EApplicationPGKeys } from 'types';
import { TableCellProps } from '../../../types';
import { Flex } from '@chakra-ui/react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {cellProps.row.uni || UNKNOWN_VALUE}
    </Flex>
  );
});

export const UniversityNameColumn = (): IColumn => ({
  item: {
    key: EApplicationPGKeys.UNI,
    name: 'Uni',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(104px, .5fr)',
    formatter: Formatter,
  },
  visible: () => true,
});
